import React from 'react'
import {
    Form,
    Input,
    Button,
    Row,
    Col,
    Divider,
    Select,
    Spin,
    Table,
    notification,
    Statistic,
    Card,
} from 'antd';
import debounce from 'lodash/debounce'
import API from '../../../services/API'

// eslint-disable-next-line prefer-destructuring
const Option = Select.Option

// function hasErrors(fieldsError) {
//     return Object.keys(fieldsError).some(field => fieldsError[field]);
// }

const getRandomId = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

class InventoryTransferForm extends React.Component {
    constructor(props) {
        super(props);
        this.getWarehouses = debounce(this.getWarehouses, 800)
        this.getProducts = debounce(this.getProducts, 800)
        this.getSubsidiaries = debounce(this.getSubsidiaries, 800)
    }

    // eslint-disable-next-line react/state-in-constructor
    state = {
        data: {},

        subsidiarie_id: {
            key: '',
            label: '',
        },
        warehouse_id: {
            key: '',
            label: '',
        },
        product_id: {
            key: '',
            label: '',
        },
        measure_unit_id: {
            key: '',
            label: '',
        },
        subsidiaries: {
			data: [],
			loading: false,
        },
        warehouses: {
			data: [],
			loading: false,
        },
        products: {
			data: [],
			loading: false,
        },
        measureUnits: {
			data: [],
			loading: false,
        },
        quantityTo: 0,

        subsidiarieTo_id: {
            key: '',
            label: '',
        },
        warehouseTo_id: {
            key: '',
            label: '',
        },
        subsidiariesTo: {
			data: [],
			loading: false,
        },
        warehousesTo: {
			data: [],
			loading: false,
        },
        productsToWarehouse: [],
        productsToWarehouseIds: [],
        warehouseSearch: '',

        querySubsidiarySource: '',
        querySubsidiaryTarget: '',
        queryWarehouseSource: '',
        queryWarehouseTarget: '',
    }

    componentDidMount() {
        // To disabled submit button at the beginning.
        this.getResourceTypeahead(
			'subsidiaries',
			`/api/subsidiaries?filter[name]=&perPage=50`,
			(subsidiarie) => ({
				text: `${subsidiarie.name}`,
				value: subsidiarie.id,
			}),
        )

        this.getResourceTypeahead(
			'subsidiariesTo',
			`/api/subsidiaries?filter[name]=&perPage=50`,
			(subsidiarieTo) => ({
				text: `${subsidiarieTo.name}`,
				value: subsidiarieTo.id,
			}),
		)

    }

    handleSubmit = (e) => {
        e.preventDefault();
        // const { getValues } = this.props;
        // if (getValues) {
        //     getValues(this.state.productsToWarehouse);
        // }
        const {
            productsToWarehouse,
            subsidiarieTo_id,
            warehouseTo_id,
            subsidiarie_id,
            warehouse_id,
        } = this.state;
        if (subsidiarie_id.key === '') {
            notification.error({
                message: 'Seleccione una sucursal origen.',
            });
            return;
        }
        if (warehouse_id.key === '') {
            notification.error({
                message: 'Seleccione una bodega origen.',
            });
            return;
        }
        if (subsidiarieTo_id.key === '') {
            notification.error({
                message: 'Seleccione una sucursal destino.',
            });
            return;
        }
        if (warehouseTo_id.key === '') {
            notification.error({
                message: 'Seleccione una bodega destino.',
            });
            return;
        }
        if (productsToWarehouse.length === 0) {
            notification.error({
                message: 'No hay productos para tranferir.',
            });
            return;
        }
        if (this.props.getValues) {
            this.props.getValues({
                products: productsToWarehouse,
                warehouse_id: parseInt(warehouseTo_id.key, 10),
            });
        }
    }

    getResourceTypeahead = async (resource, uri, stateCallback) => {
		try {
			await this.setState({
				[resource]: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state[resource],
					loading: true,
				},
			})
            const response = await API.get(uri)
			this.setState({
				[resource]: {
					data: response.data.data.map(stateCallback),
					loading: false,
				},
			})


		} catch (error) {
			this.setState({
				[resource]: {
					data: [],
					loading: false,
				},
            })
		}
    }

    getSubsidiaries = (search) => {
		this.getResourceTypeahead(
			'subsidiaries',
			`/api/subsidiaries?filter[name]=${search}&perPage=50`,
			(subsidiarie) => ({
				text: `${subsidiarie.name}`,
				value: subsidiarie.id,
			}),
		)
    }

    getSubsidiariesTo = (search) => {

		this.getResourceTypeahead(
			'subsidiariesTo',
			`/api/subsidiaries?filter[name]=${search}`,
			(subsidiariesTo) => ({
				text: `${subsidiariesTo.name}`,
				value: subsidiariesTo.id,
			}),
		)
    }

    getWarehouses = (search) => {
        const { subsidiarie_id } = this.state;
        if (subsidiarie_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una sucursal origen.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return;
        }
		this.getResourceTypeahead(
			'warehouses',
			`/api/warehouses?filter[name]=${search}&filter[subsidiary_id]=${subsidiarie_id.key}`,
			(warehouse) => ({
				text: `${warehouse.name}`,
				value: warehouse.id,
			}),
		)
    }

    getProducts = (search) => {
        const { warehouse_id } = this.state;
        if (warehouse_id.key === '') {
            notification.open({
                message: 'Primero debe seleccionar una bodega origen.',
                // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            });
            return;
        }
		this.getResourceTypeaheadProducts(
			`/api/inventory/product/search?filter[name]=${search}&include[]=currency&include[]=brand&include[]=productType&warehouse_id=${warehouse_id.key}&perPage=100`,
			product => ({
				text: `${product.name}`,
                value: product.id,
                product,
			}),
		)
    }

    getResourceTypeaheadProducts = async (uri, stateCallback) => {
        const { productsToWarehouseIds, productsToWarehouse } = this.state;
        try {
			await this.setState({
				products: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state.products,
					loading: true,
				},
			})
            const response = await API.get(uri)
            // eslint-disable-next-line prefer-const
            let tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse));
            /**
             * Antes de mostar los productos les corregiremos la cantidad de los que ya van a ser cargados
             */
            // eslint-disable-next-line prefer-const
            let temporalProducts = response.data.data.map(stateCallback);
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < temporalProducts.length; index++) {
                const tmpProduct = temporalProducts[index];
                if (productsToWarehouseIds.includes(tmpProduct.product.id)) {
                    const currentProductToModifyQuantityToIndex = tempProductsToWarehouse.findIndex(p => parseInt(p.product.id, 10) === parseInt(tmpProduct.product.id, 10));
                    // ${record.product.quantity - record.quantity}
                    // eslint-disable-next-line operator-assignment
                    temporalProducts[index].product.quantity = parseFloat(temporalProducts[index].product.quantity) - parseFloat(tempProductsToWarehouse[currentProductToModifyQuantityToIndex].quantity);
                }
            }
			this.setState({
				products: {
					// data: response.data.data.map(stateCallback),
					data: temporalProducts,
					loading: false,
				},
			})
		} catch (error) {
			this.setState({
				products: {
					data: [],
					loading: false,
				},
            })
		}
    }

    handleSelectChange = name => (value) => {
		this.setState({
            [name]: value,
			// data: {
			// 	...this.state.data,
			// 	[name]: value
			// }
		})
    }

    handleSelectProductChange = (value) => {
        this.setState({
            product_id: value,
            currentQty: 0,
        });
    }

    handleSelectSubsidiarieChange = (value) => {
        this.setState({
            subsidiarie_id: value,
            warehouses: {
                data: [],
                loading: false,
            },
            warehouse_id: {
                key: '',
                label: '',
            },
            productsToWarehouse: [],
            productsToWarehouseIds: [],
            product_id: {
                key: '',
                value: '',
            },
        })
        this.getResourceTypeahead(
			'warehouses',
			`/api/warehouses?filter[subsidiary_id]=${value.key}`,
			warehouse => ({
				text: `${warehouse.name}`,
				value: warehouse.id,
			}),
		)
    }

    // has to
    handleSelectToSubsidiarieChange = (value) => {
        const { warehouse_id } = this.state;
        if (warehouse_id.key === '') {
            notification.error({
                message: 'Primero seleccione una bodega origen',
            });
            return;
        }
        this.setState({
            subsidiarieTo_id: value,
            warehousesTo: {
                data: [],
                loading: false,
            },
            warehouseTo_id: {
                key: '',
                label: '',
            },
        })
        this.getResourceTypeahead(
			'warehousesTo',
			`/api/warehouses?filter[subsidiary_id]=${value.key}&notIn[]=${warehouse_id.key}`,
			warehouse => ({
				text: `${warehouse.name}`,
				value: warehouse.id,
			}),
		)
    }

    handleSelectWarehouseChange = (value) => {
        const { subsidiarieTo_id } = this.state;
        this.setState({
            warehouse_id: value,
            warehousesTo: {
                data: [],
                loading: false,
            },
            warehouseTo_id: {
                key: '',
                label: '',
            },
            products: {
                data: [],
                loading: false,
            },
            productsToWarehouse: [],
            productsToWarehouseIds: [],
            product_id: {
                key: '',
                value: '',
            },
        })
        if (subsidiarieTo_id.key !== '') {
            this.getResourceTypeahead(
                'warehousesTo',
                `/api/warehouses?filter[subsidiary_id]=${subsidiarieTo_id.key}&notIn[]=${value.key}`,
                (warehouse) => ({
                    text: `${warehouse.name}`,
                    value: warehouse.id,
                }),
            )
        }
    }

    handleSelectToWarehouseChange = (value) => {
        this.setState({
            warehouseTo_id: value,
        })
    }

    addToWarehouse = () => {
        const {
            quantityTo,
            productsToWarehouse,
            productsToWarehouseIds,
        } = this.state;
        const currentProduct = this.state.products.data.filter(a => parseInt(a.value, 10) === parseInt(this.state.product_id.key, 10));
        if (!currentProduct[0]) {
            return
        }
        /**
         * Esta es la validacion de cantidad, ya se valida contra los de memoria, eso se hace desde que se selecciona el producto
         */
        const currentQty = parseFloat(currentProduct[0].product.quantity);
        if (quantityTo < 0 || quantityTo === 0) {
            notification.error({
                message: 'La cantidad de productos requerida es invalida.',
            });
            return;
        }
        if (quantityTo > currentQty) {
            notification.error({
                message: 'La cantidad de productos requerida no esta disponible.',
            });
            return;
        }

        /**
         * Hay que hhacer una validacion contra memoria local, esa cantidad la vamos a sacar de productsToWarehouse
         */

        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse));
        // eslint-disable-next-line prefer-const
        let tempProductsToWarehouseIds = JSON.parse(JSON.stringify(productsToWarehouseIds));
        /**
         * Hay  que revisar si el producto se ya esta cargado o si es nuevo
         */
        if (tempProductsToWarehouseIds.includes(currentProduct[0].product.id)) {
            /**
             * Si ya existe sumamos las cantidades de memoria contra las que se recben
             */
            const currentProductToModifyQuantityToIndex = tempProductsToWarehouse.findIndex(p => parseInt(p.product.id, 10) === parseInt(currentProduct[0].product.id, 10));
            // eslint-disable-next-line operator-assignment
            tempProductsToWarehouse[currentProductToModifyQuantityToIndex].quantity = parseFloat(tempProductsToWarehouse[currentProductToModifyQuantityToIndex].quantity) + parseFloat(quantityTo);
        } else {
            tempProductsToWarehouse.push({
                uid: getRandomId(8),
                product: currentProduct[0].product,
                quantity: quantityTo,
            });
            tempProductsToWarehouseIds.push(currentProduct[0].product.id);
        }

        /**
         * Aqui es donde se hace la validacion de las cantidades, para que solo se calcule cuando se agregen productos a la memoria
        */
        const { products } = this.state;
        // eslint-disable-next-line prefer-const
        let tempProducts = JSON.parse(JSON.stringify(products.data));

        /*
        * Recorremos los productos existentes para modificar la cantidad de base de datos contra la de cantidad en memoria (temporal)
        * Si es que meten el mismo producto mas de una 1 vez
        * Ojo es para el select de productos
        */
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < tempProductsToWarehouse.length; index++) {
            const tmpProd = tempProductsToWarehouse[index];
            if (parseInt(tmpProd.product.id, 10) === parseInt(currentProduct[0].product.id, 10)) {
                // Buscamos el producto agregado en el arreglo de data del select
                const productToModifyQuantityIndex = tempProducts.findIndex(p => parseInt(p.value, 10) === parseInt(currentProduct[0].product.id, 10));
                // Aqui restamos lo que vamos calculando menos lo que vaya entrando
                // Si aun no se calcula nada solo restara la cantidad con la que viene de base de datos
                // Modificamos el row del select de productos
                // eslint-disable-next-line operator-assignment
                tempProducts[productToModifyQuantityIndex].product.quantity = parseFloat(tempProducts[productToModifyQuantityIndex].product.quantity) - parseFloat(quantityTo);
                // Modificamos el row del productsToWarehouse cargado para que sepa cuantos quedan despues del calculo
                tempProductsToWarehouse[index].product.quantity = tempProducts[productToModifyQuantityIndex].product.quantity;
            }
        }

        this.setState({
            productsToWarehouse: tempProductsToWarehouse,
            productsToWarehouseIds: tempProductsToWarehouseIds,
            product_id: {
                key: '',
                label: '',
            },
            quantityTo: 0,
            // Aqui ya modificamos la cantidad del producto restando de memoria y reintegramos el arreglo
            products: {
                data: tempProducts,
                loading: false,
            },
        });
    }

    renderFromColumn = () => (
            <Col lg={12}>
                <Form.Item label="Desde sucursal">
                    <Select
                        showSearch
                        labelInValue
                        value={this.state.subsidiarie_id}
                        disabled={this.state.productsToWarehouse.length !== 0}
                        placeholder="Busca una sucursal"
                        notFoundContent={
                            this.state.subsidiaries
                                .loading ? (
                                <Spin size="small" />
                            ) : (
                                'No hay resultados'
                            )
                        }
                        filterOption={false}
                        // onSearch={this.getSubsidiaries}
                        onSearch={(value) => {
                            this.setState({ querySubsidiarySource: value })
                        }}
                        onChange={this.handleSelectSubsidiarieChange}
                        style={{ width: '100%' }}
                    >
                        {this.state.subsidiaries.data.filter(g => g.text.toLowerCase().includes(this.state.querySubsidiarySource)).map(
                            d => (
                                <Option key={d.value}>
                                    {d.text}
                                </Option>
                            ),
                        )}
                    </Select>
                </Form.Item>
                <Form.Item label="Bodega">
                    <Select
                        showSearch
                        labelInValue
                        value={this.state.warehouse_id}
                        placeholder="Busca una bodega"
                        notFoundContent={
                            this.state.warehouses
                                .loading ? (
                                <Spin size="small" />
                            ) : (
                                'No hay resultados'
                            )
                        }
                        onSearch={(value) => {
                            this.setState({ queryWarehouseSource: value })
                        }}
                        disabled={this.state.productsToWarehouse.length !== 0}
                        optionFilterProp="children"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        onChange={this.handleSelectWarehouseChange}
                        style={{ width: '100%' }}
                    >
                        {this.state.warehouses.data.filter(g => g.text.toLowerCase().includes(this.state.queryWarehouseSource)).map(
                            (d) => (
                                <Option key={d.value}>
                                    {d.text}
                                </Option>
                            ),
                        )}
                    </Select>
                </Form.Item>
            </Col>
        )

    renderToColumn = () => (
            <Col lg={12}>
                <Form.Item label="Para sucursal">
                    <Select
                        showSearch
                        labelInValue
                        value={this.state.subsidiarieTo_id}
                        placeholder="Busca una sucursal"
                        notFoundContent={
                            this.state.subsidiariesTo
                                .loading ? (
                                <Spin size="small" />
                            ) : (
                                'No hay resultados'
                            )
                        }
                        filterOption={false}
                        // onSearch={this.getSubsidiariesTo}
                        onSearch={(value) => {
                            this.setState({ querySubsidiaryTarget: value })
                        }}
                        onChange={this.handleSelectToSubsidiarieChange}
                        style={{ width: '100%' }}
                    >
                        {this.state.subsidiariesTo.data.filter(g => g.text.toLowerCase().includes(this.state.querySubsidiaryTarget)).map(
                            d => (
                                <Option key={d.value}>
                                    {d.text}
                                </Option>
                            ),
                        )}
                    </Select>
                </Form.Item>
                <Form.Item label="Bodega">
                    <Select
                        showSearch
                        labelInValue
                        value={this.state.warehouseTo_id}
                        placeholder="Busca una bodega"
                        notFoundContent={
                            this.state.warehousesTo
                                .loading ? (
                                <Spin size="small" />
                            ) : (
                                'No hay resultados'
                            )
                        }
                        optionFilterProp="children"
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        onChange={this.handleSelectToWarehouseChange}
                        style={{ width: '100%' }}
                        onSearch={(value) => {
                            this.setState({ querySubsidiaryTarget: value })
                        }}
                    >
                        {this.state.warehousesTo.data.filter(g => g.text.toLowerCase().includes(this.state.queryWarehouseTarget)).map(
                            d => (
                                <Option key={d.value}>
                                    {d.text}
                                </Option>
                            ),
                        )}
                    </Select>
                </Form.Item>
            </Col>
        )

    removeProductFromWarehouse = async (uid, product_id) => {

        const { productsToWarehouse, productsToWarehouseIds, products } = this.state;
        // eslint-disable-next-line prefer-const
        let tempProducts = JSON.parse(JSON.stringify(products.data));
        const tempProductsToWarehouse = JSON.parse(JSON.stringify(productsToWarehouse));
        const tempProductsToWarehouseIds = JSON.parse(JSON.stringify(productsToWarehouseIds));

        const productToModifyQuantityIndex = await tempProducts.findIndex(p => parseInt(p.value, 10) === parseInt(product_id, 10));
        const productToModifyQuantityPlusIndex = await tempProductsToWarehouse.findIndex(p => p.uid === uid);

        tempProducts[productToModifyQuantityIndex].product.quantity = await parseFloat(tempProducts[productToModifyQuantityIndex].product.quantity) + parseFloat(tempProductsToWarehouse[productToModifyQuantityPlusIndex].quantity);

        const newProductsToWarehouse = tempProductsToWarehouse.filter(g => g.uid !== uid);
        const newProductsToWarehouseIds = tempProductsToWarehouseIds.filter(g => g !== product_id);
        this.setState({
            productsToWarehouse: newProductsToWarehouse,
            productsToWarehouseIds: newProductsToWarehouseIds,
            products: {
                data: tempProducts,
                loading: false,
            },
            product_id: {
                key: '',
                label: '',
            },
        });
    }

    renderProductForm = () => {
        let currentProduct = this.state.products.data.filter(a => parseInt(a.value, 10) === parseInt(this.state.product_id.key, 10));
        let printSelect = true;
        let extraHeaderContent = null;
        if (currentProduct.length === 0) {
            currentProduct = [{
                product: {
                    name: 'No hay producto seleccionado',
                    warehouse_name: '',
                    quantity: '',
                    sku: '',
                    barcode: '',
                },
            }];
        } else {
            printSelect = false;
            extraHeaderContent = (
                <Row gutter={16}>
                    <Col span={7} />
                    <Col span={8}>
                        <Input
                            addonBefore="Cantidad"
                            addonAfter={currentProduct[0].product.measure_unit_description}
                            value={this.state.quantityTo}
                            onChange={({ target }) => {
                                this.setState({ quantityTo: target.value })
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            icon="plus"
                            style={{
                                backgroundColor: '#3cb94d',
                                color: '#fff',
                            }}
                            onClick={this.addToWarehouse}
                        // eslint-disable-next-line react/jsx-closing-tag-location
                        >
                            Agregar
                        </Button>
                    </Col>
                    <Col span={4}>
                        <Button
                            type="primary"
                            onClick={() => this.setState({ product_id: { key: '', label: '' } })}
                            // eslint-disable-next-line react/jsx-closing-tag-location
                        >
                            Buscar otro producto
                        </Button>
                    </Col>
                </Row>
            );
            currentProduct.push({
                product: {
                    name: 'Cantidad a transferir',
                    warehouse_name: 'inputField',
                    sku: '',
                    barcode: '',
                    quantity: '',
                    measure_unit_description: currentProduct[0].product.measure_unit_description,
                },
            });
        }
        const titlecard = printSelect ? 'Busca un producto' : currentProduct[0].product.name;
        return (
            <Card
                title={titlecard}
                headStyle={{ backgroundColor: '#fafafa' }}
                extra={extraHeaderContent}
            >
                <div style={{ width: '100%' }}>
                    {
                        printSelect ? (
                            <Form.Item>
                                <Select
                                    showSearch
                                    labelInValue
                                    value={this.state.product_id}
                                    placeholder="Busca un producto"
                                    notFoundContent={
                                        this.state.products
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    filterOption={false}
                                    onSearch={this.getProducts}
                                    onChange={this.handleSelectProductChange}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.products.data.map(
                                        d => (
                                            <Option key={d.value}>
                                                {d.text}
                                            </Option>
                                        ),
                                    )}
                                </Select>
                            </Form.Item>
                        ) : (null)
                    }
                </div>
                {printSelect ? null : this.renderProductDescription(currentProduct)}
            </Card>
        );
    }

    renderProductDescription = (currentProduct) => {
        if (!currentProduct[0] || !currentProduct[0].product || currentProduct[0].product.inactive) {
            return null;
        }
        return (
            <React.Fragment>
                <Row gutter={16}>
                    <Col span={8}>
                        <Statistic title="Codigo de barra" value={currentProduct[0].product.barcode} decimalSeparator="" />
                    </Col>
                    <Col span={8}>
                        <Statistic title="SKU" value={currentProduct[0].product.sku?currentProduct[0].product.sku:'-'} decimalSeparator="" />
                    </Col>
                    <Col span={8}>
                        <Statistic title="Cantidad bodega" value={currentProduct[0].product.quantity} valueStyle={{ color: '#3f8600' }} />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderWarehouseFont = () => {
        const columns = [{
            title: 'Producto',
            dataIndex: 'product',
            key: 'uid',
            render: (label, record) => record.product.name,
        },
        {
            title: 'Cantidad actual',
            // dataIndex: 'currentQuantity',
            // key: 'product.quantity',
            render: (label, record) => `${record.product.quantity} ${record.product.measure_unit_description}`,
        },
        {
            title: 'Cantidad a transferir',
            // dataIndex: 'currentQuantity',
            // key: 'product.quantity',
            render: (label, record) => `${record.quantity} ${record.product.measure_unit_description}`,
        }];
        return (
            <Col lg={12}>
                <Divider>Bodega origen</Divider>
                <div style={{ width: '100%' }}>
                    <Table dataSource={this.state.productsToWarehouse} columns={columns} />
                </div>
            </Col>
        );
    }

    renderWarehouseTo = () => {
        const columns = [{
            title: 'Producto',
            dataIndex: 'product',
            key: 'uid',
            render: (label, record) => record.product.name,
        },
        {
            title: 'Cantidad',
            // dataIndex: 'currentQuantity',
            // key: 'product.quantity',
            render: (label, record) => `${record.quantity}`,
        },
        {
            title: 'Acción',
            // dataIndex: 'product.quantity',
            key: 'product.quantity',
            render: (label, record) => (
                <div key={record.uid}>
                    <Button
                        type="danger"
                        shape="circle"
                        icon="delete"
                        size="small"
                        onClick={() => this.removeProductFromWarehouse(record.uid, record.product.id)}
                    />
                </div>
            ),
        }];
        return (
            <Col lg={12}>
                <Divider>Bodega destino</Divider>
                <div style={{ width: '100%' }}>
                    <Table dataSource={this.state.productsToWarehouse} columns={columns} />
                </div>
            </Col>
        );
    }

    render() {
        return (
            <React.Fragment>
                <Form>
                    <Row gutter={16}>
                        {this.renderFromColumn()}
                        {this.renderToColumn()}
                    </Row>
                    {this.renderProductForm()}
                    <Row gutter={16}>
                        {this.renderWarehouseFont()}
                        {this.renderWarehouseTo()}
                    </Row>
                </Form>
                <Divider />
                <Row type="flex" justify="center">
                    <Col>
                        <Button
                            type="primary"
                            size="large"
                            icon="swap"
                            disabled={this.state.productsToWarehouseIds.length === 0}
                            onClick={this.handleSubmit}
                        >
                            Transferir
                        </Button>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

const WrappedInventoryTransferForm = Form.create({ name: 'InventoryEntryVerticalForm' })(InventoryTransferForm);
export default WrappedInventoryTransferForm;
